import type { ChangeEvent, FC, ReactElement } from "react";

import type { Money, SubscriptionResponse } from "~/generated/graphql";
import type {
  MembershipPageRouterActions,
  MembershipPageRouterProps,
} from "../../../MembershipPageRouter/contract";

export enum SubscriptionMultiOfferFares {
  PLUS = "plus",
  BASIC = "basic",
  NONPRIME = "nonPrime",
}

export enum SubscriptionMultiOfferTabOffers {
  PLUS = "plus",
  BASIC = "basic",
}

export enum SubscriptionMultiOfferPeriod {
  FREE_TRIAL = "FREE_TRIAL",
}

export interface onFareSelectedArgs {
  fareSelected: SubscriptionMultiOfferFares;
  tabOfferSelected: SubscriptionMultiOfferTabOffers;
  wasPrimeSelectedInResults: boolean;
  isUserLogged: boolean;
  subscriptionPeriod: string;
}

export interface onContinueArgs {
  isFencedScope: boolean;
  userAction: string;
}

export interface onContinuePrimeExtraDiscountArgs extends onContinueArgs {
  fareSelected: SubscriptionMultiOfferFares;
}

export interface onMoreInfodArgs {
  fareSelected: SubscriptionMultiOfferFares;
  wasPrimeSelectedInResults: boolean;
  isUserLogged: boolean;
  subscriptionPeriod: string;
}

export interface SubscriptionMultiOfferTemplateActions
  extends MembershipPageRouterActions {
  onFareSelected: (offerSelectedId: string, offerTabActive: string) => void;
  onTabSelected?: (tab: SubscriptionMultiOfferTabOffers) => void;
}

export interface SubscriptionMultiOfferTemplateVariables {
  bookingPrice: Money;
  membershipFee: Money;
  offer: Array<SubscriptionResponse>;
  wasPrimeSelectedInResults: boolean;
  email: string;
  isUserLogged: boolean;
  isEmailRegistered: boolean;
  isWaitingToContinue: boolean;
  defaultOfferName?: string;
  hideNonPrimeFare?: boolean;
  showTotalPrice?: boolean;
}

export interface SubscriptionMultiOfferTemplateProps {
  actions: SubscriptionMultiOfferTemplateActions;
  variables: SubscriptionMultiOfferTemplateVariables;
  loading?: boolean;
  routerProps: MembershipPageRouterProps;
  isPrimeDays?: boolean;
  isBlackFriday?: boolean;
}

export interface SubscriptionMultiOfferVariantBaseProps {
  template: FC<SubscriptionMultiOfferTemplateProps>;
  routerProps: MembershipPageRouterProps;
  isPrimePlusDefault?: boolean;
  hasPopup?: boolean;
  validatePerks?: boolean;
  validateMeta?: boolean;
  usePlusOffer?: boolean;
  hideNonPrimeFare?: boolean;
  showTotalPrice?: boolean;
}

export interface HeaderBannerProps {
  showBannerWithText?: boolean;
  bannerText: string | ReactElement;
  discountedPrice?: Money;
}

export interface TabSelectorProps {
  activeTab: SubscriptionMultiOfferTabOffers;
  onTabChange: (
    _event: ChangeEvent<HTMLElement>,
    tabSelected: SubscriptionMultiOfferTabOffers,
  ) => void;
  texts: {
    plusTab: string;
    basicTab: string;
  };
}

export const NO_OFFER_SELECTED_ID = "0";
